// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a0e99d0b","277":"09cc2a5a","453":"d855a71b","455":"20b029ec"}[chunkId] + ".chunk.js";
};